import sendToServer from "./send-to-server";
import Sortable from "sortablejs";

const Cvs = {
  init() {
    if (!($(".cvs").length > 0)) return;

    // Requirement components
    $(".choose-option").click(this.handleChoseOption.bind(this));
    $(".existing-role").click(this.handleClickedExistingRole.bind(this));
    $(".new-role-toggle").click(this.handleClickedNewRoleToggle.bind(this));
    $(".role-next").click(this.handleClickedRoleNext.bind(this));
    $(".existing-qualification").click(
      this.handleClickedExistingQualification.bind(this)
    );
    $(".new-qualification-toggle").click(
      this.handleClickedNewQualificationToggle.bind(this)
    );
    $(".qualification-next").click(
      this.handleClickedQualificationNext.bind(this)
    );
    $(".use-badge").click(this.handleClickedUseBadge.bind(this));
    $(".cancel-option").click(this.handleClickedCancelOption.bind(this));

    // CV Viewer
    $(".document-viewer.editable .cv-component").mouseover(
      this.handleMouseoverCvComponent.bind(this)
    );
    $(".document-viewer.editable .cv").mouseleave(
      this.handleMouseleaveCv.bind(this)
    );
    $(".document-viewer.editable .cv-component").click(
      this.handleCvComponentClick.bind(this)
    );
    $(".cancel-button").click(this.handleCancelButtonClick.bind(this));
    $(".edit-submit-button").click(this.handleSubmitEditButtonClick.bind(this));
    $(".create-submit-button").click(
      this.handleSubmitCreateButtonClick.bind(this)
    );
    $(".add-qualification-button").click(
      this.handleQualificationAddButtonClick.bind(this)
    );
    $(".add-role-button").click(this.handleRoleAddButtonClick.bind(this));
    $(".add-hobby-button").click(this.handleHobbyAddButtonClick.bind(this));
    $(".add-referee-button").click(this.handleRefereeAddButtonClick.bind(this));
    $(".add-child-button").click(this.handleChildAddButtonClick.bind(this));
    $(".delete-button").click(this.handleDeleteButtonClick.bind(this));

    // Experience components
    $(".question-strip .submitter").click(this.handleSubmitterClick.bind(this));
    $(".question-strip .exiter").click(this.handleExiterClick.bind(this));
    $(".onboarding .content").click(
      this.handleOnboardingContentClick.bind(this)
    );
  },

  handleChoseOption(event) {
    const $button = $(event.target);
    $(".requirement-options").fadeOut(300, () => {
      switch ($button.data("component-class")) {
        case "CvComponent::RoleBullet":
          $(".role-box").fadeIn();
          break;
        case "CvComponent::Hobby":
          $(".hobby-box").fadeIn();
          break;
        case "CvComponent::QualificationBullet":
          $(".qualification-box").fadeIn();
          break;
      }
    });
  },

  handleClickedCancelOption(event) {
    $(".input-box").fadeOut(() => {
      $(".requirement-options").fadeIn();
    });
  },

  handleClickedExistingRole(event) {
    const $button = $(event.target);
    $("#role-parent-id-field").val($button.data("component-id"));
    $("#role-component-type-field").val("role-bullet");
    this.handleClickedRoleNext();
  },

  handleClickedNewRoleToggle() {
    $(".existing-roles").fadeOut(300, () => {
      $(".new-role").fadeIn();
    });
  },

  handleClickedRoleNext() {
    $(".role-box .stage-1").fadeOut(300, () => {
      $(".role-box .stage-2").fadeIn();
    });
  },

  handleClickedExistingQualification(event) {
    const $button = $(event.target);
    $("#qualification-parent-id-field").val($button.data("component-id"));
    $("#qualification-component-type-field").val("qualification-bullet");
    this.handleClickedQualificationNext();
  },

  handleClickedNewQualificationToggle() {
    $(".existing-qualifications").fadeOut(300, () => {
      $(".new-qualification").fadeIn();
    });
  },

  handleClickedQualificationNext() {
    $(".qualification-box .stage-1").fadeOut(300, () => {
      $(".qualification-box .stage-2").fadeIn();
    });
  },

  handleMouseoverCvComponent(event) {
    $(".cv-component").removeClass("hovering");
    if (
      event.target
        .closest(".cv-component")
        .classList.contains("cv-component-skills")
    ) {
      return;
    }
    const $component = $(event.target).closest(".cv-component");
    $component.addClass("hovering");
  },

  handleMouseleaveCv() {
    $(".cv-component").removeClass("hovering");
  },

  handleCvComponentClick(event) {
    const $component = $(event.target).closest(".cv-component");
    let $editBox = null;
    [
      "header",
      "education",
      "qualification",
      "employment",
      "qualification-bullet",
      "role",
      "role-bullet",
      "hobbies",
      "hobby",
      "referees",
      "referee",
    ].forEach((cType) => {
      if ($component.hasClass("cv-component-" + cType)) {
        $editBox = $("." + cType + "-edit-box");
      }
    });

    if (!$editBox) return;

    const props = $component.data("props");
    for (let key in props) {
      $editBox.find('[name="' + key + '"]').val(props[key]);
    }
    $editBox.find('[name="component_id"]').val($component.data("component-id"));

    if ($component.data("embedded-children")) {
      const $childrenSection = $editBox.find(".children");
      $childrenSection.html("");
      $component.data("embedded-children").forEach((child) => {
        const childInput = $("<input>", {
          type: "text",
          value: child.text,
          "data-component-id": child.id,
        });
        $childrenSection.append(childInput);
      });
      $childrenSection.append($("<input>", { type: "text" }));
    } else if ($component.data("embedded-summaries")) {
      const $summariesSection = $editBox.find(".summaries");
      $summariesSection.html("");
      $component.data("embedded-summaries").forEach((summary) => {
        const $summaryRow = $("<div>", {
          class: "reorderable-child",
          "data-component-id": summary.id,
        });
        const $moveableBit = $("<span>", {
          class: "moveable",
          text: summary.text,
        });
        $summaryRow.append($moveableBit);
        $summariesSection.append($summaryRow);
      });

      Sortable.create($editBox.find(".summaries")[0], {
        handle: ".moveable",
        onEnd: () => {
          this.handleReordering($editBox);
        },
      });
    }

    $(document).scrollTop(0);
    $editBox.fadeIn(100);
  },

  handleCancelButtonClick() {
    $(".edit-box").fadeOut(100);
  },

  handleSubmitEditButtonClick(event) {
    const $editBox = $(event.target).closest(".edit-box");
    const data = { _children: [] };
    $editBox.find("input, select, textarea").each((_index, element) => {
      const $elem = $(element);
      if ($($elem).prop("name")) data[$($elem).prop("name")] = $elem.val();
    });

    $editBox.find(".children input").each((_idx, element) => {
      const $elem = $(element);
      data._children.push({
        id: $elem.data("component-id"),
        text: $elem.val(),
      });
    });

    sendToServer(
      "/api/v2/cv_components/" + data["component_id"],
      data,
      () => {
        location.reload();
      },
      "PATCH"
    );
  },

  handleSubmitCreateButtonClick(event) {
    const $editBox = $(event.target).closest(".edit-box");
    const data = { _children: [] };
    $editBox.find("input, select, textarea").each((_index, element) => {
      const $elem = $(element);
      if ($($elem).prop("name")) data[$($elem).prop("name")] = $elem.val();
    });

    $editBox.find(".children input").each((_idx, element) => {
      const $elem = $(element);
      data._children.push({ text: $elem.val() });
    });

    sendToServer("/api/v2/cv_components/", data, () => {
      location.reload();
    });
  },

  handleDeleteButtonClick(event) {
    const $editBox = $(event.target).closest(".edit-box");
    const componentId = $editBox.find('[name="component_id"]').val();
    sendToServer(
      "/api/v2/cv_components/" + componentId,
      null,
      () => {
        location.reload();
      },
      "DELETE"
    );
  },

  handleQualificationAddButtonClick() {
    $(".education-edit-box").fadeOut(100, () => {
      $(".qualification-create-box").fadeIn(100);
    });
  },

  handleRoleAddButtonClick() {
    $(".employment-edit-box").fadeOut(100, () => {
      $(".role-create-box").fadeIn(100);
    });
  },

  handleHobbyAddButtonClick() {
    $(".hobbies-edit-box").fadeOut(100, () => {
      $(".hobby-create-box").fadeIn(100);
    });
  },

  handleRefereeAddButtonClick() {
    $(".referees-edit-box").fadeOut(100, () => {
      $(".referee-create-box").fadeIn(100);
    });
  },

  handleChildAddButtonClick(event) {
    const $childrenSection = $(event.target)
      .closest(".edit-box")
      .find(".children");
    $childrenSection.append($("<input>", { type: "text" }));
  },

  handleSubmitterClick(event) {
    const button = $(event.target).closest(".submitter");
    const scope = button.data("scope");
    var data = {};
    const valOf = (name) => {
      return $('[name="' + name + '"]').val();
    };
    switch (scope) {
      case "education-A":
        data = {
          component_type: "qualification",
          institution: valOf("current_institution"),
          content:
            valOf("course_qualification") + " " + valOf("course_subject"),
          start_year: valOf("course_start_year"),
          end_year: valOf("course_end_year"),
        };
        break;
      case "education-B":
        data = {
          component_type: "qualification",
          institution: valOf("course_b_institution"),
          content: valOf("course_b_content"),
          text: valOf("course_b_text"),
          start_year: valOf("course_b_start_year"),
          end_year: valOf("course_b_end_year"),
        };
        break;
      case "employment":
        data = {
          component_type: "role",
          employer: valOf("employment_employer"),
          title: valOf("employment_title"),
          start_year: valOf("employment_start_year"),
          end_year: valOf("employment_end_year"),
          start_month: valOf("employment_start_month"),
          end_month: valOf("employment_end_month"),
        };
        break;
    }

    data.cv_id = $(".question-strip").data("cv-id");

    sendToServer("/api/v2/cv_components", data);

    $('input[type="text"]').val("");
    $("option").prop("selected", false);
  },

  handleExiterClick() {
    window.location =
      "/app/cvs/" +
      $(".question-strip").data("cv-id") +
      "/requirement_components/new";
  },

  handleReordering($editBox) {
    this.handleCancelButtonClick();
    let payload = {};
    $editBox.find(".reorderable-child").each((index, element) => {
      payload[$(element).data("component-id")] = index;
    });
    const componentId = $editBox.find('[name="component_id"]').val();
    sendToServer(
      "/api/v2/cv_components/" + componentId + "/child_order",
      { order: payload },
      () => {
        location.reload();
      }
    );
  },

  handleOnboardingContentClick(event) {
    const clicked = $(event.target).closest(".content");
    const next = clicked.next();
    if (next.length === 0) {
      $(".onboarding").hide();
      sendToServer("/api/v2/me", { seen_cv_onboarding: true }, null, "PATCH");
    }

    clicked.removeClass("visible");
    next.addClass("visible");

    const linkedElements = {
      "onboarding-content-2": ".cv-component-header",
      "onboarding-content-3": ".cv-component-employment",
      "onboarding-content-4": ".cv-component-hobbies",
      "onboarding-content-5": ".cv-component-referees",
      "onboarding-content-6": ".download-link",
    };

    const relevantSelector = linkedElements[next.prop("id")];

    if (relevantSelector) {
      next.css("margin-top", $(relevantSelector).offset().top - 50 + "px");
      $("html, body").animate(
        { scrollTop: $(relevantSelector).offset().top },
        300
      );
    }
  },

  handleClickedUseBadge(event) {
    const $button = $(event.target);
    const template = $button.data("template");
    const skillName = $button.data("skill-name");
    const level = $button.data("badge-level");
    const text = template
      .replace("[SKILL]", skillName)
      .replace("[LEVEL]", level);
    $('.hobby-box [name="text"').val(text);
    $(".hobby-box form").submit();
  },
};

$(document).ready(() => {
  Cvs.init();
});
